import React, { FC } from 'react';
import { parseQueryParamToNumbers } from 'utils/url';
import { ModalManager, ModalRouteProps } from 'context/ModalRouter';
import { usePostsContainer } from 'components/posts/context';
import { useInvalidatePostsQueries } from '../../hooks/useInvalidatePostsQueries';
import MovePostsToTrashModal from './components/MovePostsToTrashModal';

type Props = {
  modalManager: ModalManager;
} & ModalRouteProps;

const MovePostsToTrashRoute: FC<Props> = (props) => {
  const postsContainer = usePostsContainer();
  const invalidatePostsQueries = useInvalidatePostsQueries();

  const modalManager: ModalManager = {
    ...props.modalManager,
    close: () => {
      props.modalManager.close();
      invalidatePostsQueries();
      postsContainer.clearSelectedPosts();
    },
  };

  const initialPostsIds = parseQueryParamToNumbers(
    modalManager.getQueryParameter('posts'),
  );
  const initialPosts = postsContainer.posts.allPosts.filter((post) =>
    initialPostsIds.includes(post.id),
  );

  return (
    <MovePostsToTrashModal
      modalManager={modalManager}
      initialPosts={initialPosts}
    />
  );
};

export default MovePostsToTrashRoute;
